module.exports = __webpack_public_path__ + "static/media/logo-dia-dos-namorados-colorido.01486102.svg";